import React, { useEffect, useState } from "react";
import { IndianRupee, ShoppingBag, Store, Utensils } from "lucide-react";
import { api } from "../../lib/api";
import { compact, rupee } from "../../lib/format";
import { StatCard, Panel, DataTable, EntitySelect } from "./ui";
import { Header, Loading } from "./CorporateDashboard";

export default function GroupDashboard({ ctx, user }) {
  const groups = ctx.groups;
  const [groupId, setGroupId] = useState(user.group_id || groups[0]?.id);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!groupId) return;
    setData(null);
    api.get(`/dashboard/group/${groupId}`).then((r) => setData(r.data));
  }, [groupId]);

  const selector = (
    <EntitySelect label="Group" value={groupId} onChange={setGroupId} testid="group-select"
      options={groups.map((g) => ({ value: g.id, label: g.name }))} />
  );

  if (!data) return <div className="space-y-6"><Header title="Restaurant Group" right={selector} /><Loading /></div>;
  const m = data.metrics;

  return (
    <div className="space-y-6">
      <Header title={data.group?.name || "Group"} sub={`${data.group?.legal_entity || ""} · GSTIN ${data.group?.gstin || ""}`} right={selector} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={IndianRupee} label="Total Group Sales" value={compact(m.sales)} testid="stat-group-sales" />
        <StatCard icon={ShoppingBag} label="Orders" value={m.orders} sub={`AOV ${rupee(m.aov)}`} accent="blue" />
        <StatCard icon={Utensils} label="Items Sold" value={m.items} accent="emerald" />
        <StatCard icon={Store} label="Brands" value={data.restaurants.length} accent="gold" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Panel title="Restaurant Breakdown">
          <DataTable testid="group-rest-table"
            columns={[
              { key: "restaurant", label: "Brand" },
              { key: "orders", label: "Orders" },
              { key: "items", label: "Items" },
              { key: "sales", label: "Sales", render: (r) => <span className="gold-text font-semibold">{rupee(r.sales)}</span> },
              { key: "aov", label: "AOV", render: (r) => rupee(r.aov) },
            ]} rows={data.restaurants} />
        </Panel>
        <Panel title="Top Items (Group-wide)">
          <DataTable testid="group-item-table"
            columns={[
              { key: "name", label: "Item" },
              { key: "qty", label: "Qty" },
              { key: "revenue", label: "Revenue", render: (r) => rupee(r.revenue) },
            ]} rows={data.top_items} />
        </Panel>
      </div>
    </div>
  );
}
